"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExampleSortBy = void 0;
const react_1 = __importDefault(require("react"));
const ExampleSortBy = props => {
  var _a;
  return react_1.default.createElement("select", {
    className: "rs__sortby__select",
    value: (_a = props.sortOption) === null || _a === void 0 ? void 0 : _a.handle,
    onChange: event => props.setSortOption(event.target.value)
  }, props.sortOptions.map(sortOption => react_1.default.createElement("option", {
    key: sortOption.handle,
    className: "rs__sortby__option",
    value: sortOption.handle
  }, sortOption.name)));
};
exports.ExampleSortBy = ExampleSortBy;